import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { BG_IMAGE_ALIGNMENT_OPTIONS, BgImageAlignmentOptions, Icon } from '#const';
import { getIconUrl } from '#utils';

const FormModal = dynamic(() => import('./FormModal'), {
	ssr: false,
});

Builder.registerComponent(FormModal, {
	name: 'FormModal',
	inputs: [
		{
			name: 'heading',
			friendlyName: 'Show Heading',
			type: 'boolean',
			defaultValue: true,
			helperText: 'Show the heading above the form',
		},
		{
			name: 'color',
			friendlyName: 'Form Heading & Border Color',
			type: 'color',
			defaultValue: 'rgba(255,219,0, 1)',
			helperText: `For the colored outline around the form,
			make sure there is enough contrast with the Heading`,
			showIf: function (options) {
				return options.get('heading') === true;
			},
		},
		{
			name: 'headingCopy',
			friendlyName: 'Heading',
			type: 'richText',
			defaultValue: `<h2>Significant Compensation Available</h2>
				<br/> <h3>See how much you may qualify for.</h3>`,

			showIf: function (options) {
				return options.get('heading') === true;
			},
		},
		{
			name: 'form',
			friendlyName: 'Form',
			type: 'reference',
			model: 'form',
			defaultValue: {
				'@type': '@builder.io/core:Reference',
				id: 'f86c3b6d48c94d8da964dd705d15438c',
				model: 'form',
			},
		},
		{
			name: 'showFinePrint',
			friendlyName: 'Show TCPA',
			type: 'boolean',
			defaultValue: true,
			helperText: `If true will show TCPA. TCPA is REQUIRED for any forms. 
			This option allows it to be removed from the first step`,
		},
		{
			name: 'showLogos',
			friendlyName: 'Show Logos',
			type: 'boolean',
			defaultValue: true,
			helperText: 'If TCPA text is shown this is an option to show or hide logos',
		},
		{
			name: 'showDynamicPhoneNumber',
			friendlyName: 'Show Dynamic Phone Number',
			type: 'boolean',
			defaultValue: false,
			helperText: 'If true will query for a dynamic phone number',
		},
		{
			name: 'finePrint',
			friendlyName: 'Fine Print',
			type: 'richText',
			required: false,
			defaultValue: `<p>
				By clicking &apos;Do I Qualify&apos; and submitting my request,
				I provide my electronic signature and consent to receive phone calls
				and/or text messages from Total Injury Help to the above telephone
				number containing offers to identify a lawyer in its network that may
				assist me. These communications may be generated using an autodialer,
				and/or pre-recorded or artificial voice, and that consent is not required
				to utilize Total Injury Help services. This authorization overrides any
				previous registrations on a federal or state Do Not Call registry. I agree
				to the <a href="/privacy-policy/" target="_blank" rel="noopener noreferrer">privacy policy</a>
				and <a href="/terms-of-use/" target="_blank" rel="noopener noreferrer">terms</a>
				(including mandatory arbitration and class waiver).
				</p>`,
		},
		{
			name: 'centered',
			friendlyName: 'Center Form',
			type: 'boolean',
			defaultValue: true,
			helperText: 'Center the form container within the modal',
		},
		{
			name: 'maxWidth',
			friendlyName: 'Form Max Width',
			type: 'number',
			defaultValue: 425,
			helperText: 'Max width of the form container in pixels (default: 425px)',
		},
		{
			name: 'backgroundImage',
			friendlyName: 'Background Image',
			type: 'object',
			required: false,
			helperText: 'Optional image placed in the background of the form.',
			subFields: [
				{
					name: 'src',
					friendlyName: 'Image',
					type: 'file',
					allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
				},
				{
					name: 'backgroundImagePlacement',
					friendlyName: 'Background Image Placement Bias',
					type: 'string',
					enum: [...BG_IMAGE_ALIGNMENT_OPTIONS],
					defaultValue: BgImageAlignmentOptions.CENTER,
					helperText: `How the background Image will attach to the background of the container.
						Use it to move the focal point of the image if needed.`,
				},
			],
		},
		{
			name: 'backgroundColor',
			friendlyName: 'Background Color',
			type: 'color',
			helperText: 'Background color behind the form, shown if no background image is provided',
		},
		{
			name: 'intakeFormId',
			friendlyName: 'Intake Form ID',
			type: 'string',
			defaultValue: '',
			helperText: `The form ID of the intake form to show after the form is submitted
			and the user qualifies for an internal intake`,
		},
	],
	canHaveChildren: false,
	image: getIconUrl(Icon.FORM),
});
